import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Dialog } from 'functional-foundations'

const useStyles = makeStyles(theme => ({
    imageDialog: {
        '& [role=dialog]': {
            padding: 0,
            '& img': {
                borderRadius: '20px'
            }
        }
    },
    imageRoot: {}
}))

/**
 *
 */
export const Image = ({ open, onClose, sources, attributes, width, height }: { open: boolean, onClose: (ev) => void, sources: React.SourceHTMLAttributes<HTMLSourceElement>[], attributes?: React.VideoHTMLAttributes<HTMLVideoElement>, autoPlay: boolean | undefined, width: number | string | undefined, height: number | string | undefined }) => {
    const classes = useStyles()
    return (
        <Dialog
            isOpen={open}
            onClose={onClose}
            aria-labelledby="image-dialog"
            data-testid='image-popup'
            className={classes.imageDialog}
            width={width}
            closeOnClickOutside={true}
            size = 'large'
        >
            {
                sources && sources.length !== 0
                    ? <img className={classes.imageRoot} width={width} height={height} src={sources[0].src} {...attributes}></img>
                    : <p>No image sources found</p>
            }
        </Dialog>

    )
}
